import React from "react";
import { Link } from "react-router-dom";

function Cancellation() {
  return (
    <div>
      <div class="Conditions-terms">
          <div className="breadcrumb">
            <Link to="/">Home</Link> /{" "}
            <Link to="/Cancellation-Policy">Cancellation policy</Link>
        </div>
        <h1 class="Condition">Cancellation policy</h1>
        <h2 class="policy">Cancellation Policy</h2>
        <div class="content">
          <p>
            {" "}
            At Sankalp Ayurveda, we strive to ensure a seamless shopping
            experience. However, we understand that there may be circumstances
            where you need to cancel an order. Please review our cancellation
            policy below:
          </p>
          <h3 class="section-title">1. General Cancellation Guidelines</h3>
          <ul class="policy-list">
            <li>
              <strong>Orders Once Dispatched:</strong>
              <ul>
                <li>
                  Orders that have already been dispatched are not eligible for
                  cancellation.
                </li>
              </ul>
            </li>

            <li>
              <strong>Discount Vouchers:</strong>
              <ul>
                <li>
                  Discount vouchers are intended for one-time use only and will
                  be considered used, even if the order is canceled.
                </li>
              </ul>
            </li>

            <li>
              <strong>Loyalty Points:</strong>
              <ul>
                <li>
                  If loyalty points were redeemed for the order, they will be
                  credited back to your account in the event of a cancellation.
                </li>
              </ul>
            </li>
          </ul>
          <h3 class="section-title">2. Refunds for Returns or Cancellations</h3>
          <ul class="policy-list">
            <li>
              <strong>Refund Process:</strong>
              <ul>
                <li>
                  Refunds will be initiated only after the product is returned
                  to us and successfully verified for its condition and
                  packaging.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cancellation;
